import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DenialTypesPipe } from './denialTypes.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [DenialTypesPipe],
    providers: [DenialTypesPipe],
    exports: [DenialTypesPipe],
})
export class DenialTypesPipeModule {}
